import { Checkbox, Grid, FormControlLabel, Button, Box } from "@mui/material"
import { ChangeEvent, useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { CancelButton } from "../../../components/CancelButton/CancelButton"
import { acceptTermsAndCondition, getTermsAndConditionsForRenewalPeriod, TermsAndConditionData } from "../../../services/ntuc/memberService/termsAndConditions"
import { Status } from "../../../services/ntuc/Model"
import { ArrearsRoute, ArrearsRouteParams } from "../ArrearsPaymentFlow/ArrearsPaymentFlow"

const TermsAndConditionsPage = (props: ArrearsRouteParams) => {
    const { onNavigateTo, routeParams } = props
    const { t } = useTranslation(`signup`)

    const [termsAndConditions, setTermsAndConditions] = useState<TermsAndConditionData | undefined>(undefined)
    const [accept, setAccept] = useState(false)

    const tncDeclaration = t(`tncDeclaration`)
    const renewalPeriod = routeParams?.fee
    const membershipId = routeParams?.membershipId

    useEffect(() => {
        if (renewalPeriod?.renewalPeriodId) {
            getTermsAndConditionsForRenewalPeriod(renewalPeriod?.renewalPeriodId)
                .then(response => response.data.content)
                .then(tAC => {
                    if (!tAC.isEnable) {
                        onNavigateTo(ArrearsRoute.MembershipPaymentSummary, { fee: renewalPeriod })
                    }
                    setTermsAndConditions(tAC)
                })
                .catch(console.error)
        } else {
            console.log(`No renewal period ID found`)
        }
    }, [renewalPeriod?.renewalPeriodId])

    const handleCheckBoxOnChange = (_event: ChangeEvent<HTMLInputElement>, checked: boolean) => {
        setAccept(checked)
    }
    const handleNextButtonOnClick = () => {
        if (renewalPeriod && membershipId) {
            acceptTermsAndCondition(membershipId, `1`)
                .then(response => {
                    if (response.data.metadata.status === Status.SUCCESS) {
                        onNavigateTo(ArrearsRoute.MembershipPaymentSummary, { fee: renewalPeriod })
                    }
                })
                .catch(console.error)
        } else {
            console.log(`No membership ID found`)
        }
    }

    const handleBackButtonClick = () => {
        onNavigateTo(ArrearsRoute.MembershipFeePayment, routeParams)
    }

    const Terms = () => {
        return (
            <Box>
                <div dangerouslySetInnerHTML={{ __html: termsAndConditions?.content ?? `` }} />
            </Box>
        )
    }

    const NextButton = () => {
        return (
            <Button
                disabled={!accept}
                variant="contained"
                color="primary"
                size="large"
                onClick={handleNextButtonOnClick}
            >
                {t(`next`)}
            </Button>
        )
    }

    const ConsentCheckBox = () => <Checkbox checked={accept} onChange={handleCheckBoxOnChange} />

    const ConsentView = () => {
        if (termsAndConditions?.content) {
            return (
                <Grid item container rowSpacing={2} direction="column" justifyContent="center">
                    <Grid item>
                        <FormControlLabel control={<ConsentCheckBox />} label={tncDeclaration} />
                    </Grid>
                    <Grid container item direction="row" justifyContent="space-evenly" alignItems="center">
                        <CancelButton onClick={handleBackButtonClick} />
                        <NextButton />
                    </Grid>
                </Grid>
            )
        } else {
            return (<div />)
        }
    }

    return (
        <Grid container padding={2} rowSpacing={2} alignContent={`center`}>
            <Terms />
            <ConsentView />
        </Grid>
    )
}

export default TermsAndConditionsPage